import { Injectable } from '@angular/core';
import { faBars, faCheckCircle, faChevronLeft, faClock as faClockSolid, faCopy, faEdit, faEnvelope, faExternalLinkSquareAlt, faFile, faFilter, faImage, faInfoCircle, faLink, faMapMarkerAlt, faMobileAlt, faPen, faPhone, faPlus, faSearch, faSms, faStar, faTags, faTimes, faUndo, faUser, faStar as faStarFull, faAddressCard, faCalendarAlt, faCreditCard, faMapMarkedAlt, faShoppingBasket, faSlidersH, faTrashAlt, faUserPlus, faUsers, faArrowAltCircleRight, faTimesCircle, faUndoAlt, faBookOpen, faFileExcel, faSitemap, faStore, faEuroSign, faCheck, faSave, faUpload, faDownload, faHeart as faHeartFull, faChevronDown, faChevronUp, faHome, faExternalLinkAlt, faGrinAlt, faLifeRing, faMedal, faWater, faExclamationCircle, faMinus, faBirthdayCake, faIdBadge, faTh, faCashRegister, faSignInAlt, faCog, faSignOutAlt, faPercentage, faBookmark, faUserCircle, faTable, faCalendarDay, faArrowAltCircleUp, faBan, faCalendarCheck, faHandsHelping, faPassport, faQuestionCircle, faVideo, faListAlt, faEye, faComment, faLock, faFileImage, faTasks, faStarAndCrescent, faNewspaper, faTrash, faRetweet, faChevronRight, faBook, faBullhorn } from '@fortawesome/free-solid-svg-icons';

import { faFilePdf, faStar as faStarEmpty, faClock as faClockRegular, faHeart as faHeartEmpty, faSquare, faUser as faUserEmpty } from '@fortawesome/free-regular-svg-icons';

@Injectable({
  providedIn: 'root'
})

export class FaiconService {

  private readonly listFaIcon = {
    faBars,
    faChevronLeft,
    faChevronRight,
    faClockSolid,
    faClockRegular,
    faPen,
    faTimes,
    faSearch,
    faTasks,
    faPlus,
    faEdit,
    faInfoCircle,
    faMapMarkerAlt,
    faStar,
    faTags,
    faExternalLinkSquareAlt,
    faUser,
    faUserEmpty,
    faPhone,
    faEnvelope,
    faSms,
    faFilePdf,
    faUndo,
    faMobileAlt,
    faImage,
    faFileImage,
    faFilter,
    faCopy,
    faStarEmpty,
    faStarFull,
    faCheckCircle,
    faLink,
    faFile,
    faShoppingBasket,
    faCreditCard,
    faTrashAlt,
    faUserPlus,
    faUsers,
    faAddressCard,
    faCalendarAlt,
    faMapMarkedAlt,
    faSliders: faSlidersH,
    faArrowAltCircleRight,
    faTimesCircle,
    faUndoAlt,
    faStore,
    faSitemap,
    faFileExcel,
    faBookOpen,
    faEuroSign,
    faUpload,
    faSave,
    faCheck,
    faDownload,
    faHeartFull,
    faHeartEmpty,
    faSquare,
    faChevronDown,
    faChevronUp,
    faHome,
    faWater,
    faMedal,
    faCalendar: faCalendarAlt,
    faGrinAlt,
    faLifeRing,
    faExternalLinkAlt,
    faMinus,
    faExclamationCircle,
    faBirthdayCake,
    faIdBadge,
    faTh,
    faCashRegister,
    faSingInAlt: faSignInAlt,
    faSignAlt: faSignInAlt,
    faCog,
    faSignOutAlt,
    faPercentage,
    faBookmark,
    faUserCircle,
    faTable,
    faCalendarDay,
    faArrowAltCircleUp,
    faBan,
    faListAlt,
    faCalendarCheck,
    faHandsHelping,
    faPassport,
    faQuestionCircle,
    faVideo,
    faEye,
    faComment,
    faLock,
    faStarAndCrescent,
    faNewspaper,
    faTrash,
    faRetweet: faRetweet,
    faBook,
    faBullhorn
  };

  constructor() { }

  getFaIcon(faicon: string): string {
    return this.listFaIcon[faicon];
  }

}
